import z from 'zod';
import { dateSchema, nameSchema } from '../../validation';
import { imageWithUploadSchema, partySchema } from '../../common';

export const orderCommentVisibilitySchema = z.enum(['carrier', 'customer', 'super_admin', 'any']);
export const orderCommentUpdateSchema = z.object({
  comment: nameSchema,
  /**
   * the author of the comment. Phase 7 (relations-v2): flipped to a
   * {@link partySchema} snapshot.
   */
  user: partySchema,
  /** who can view this comment */
  visibility: orderCommentVisibilitySchema,

  date: dateSchema,
  /** the images to be added with the comment */
  images: z.array(imageWithUploadSchema).optional(),
});
export type OrderCommentUpdate = z.infer<typeof orderCommentUpdateSchema>;
